import { FC, ReactNode } from 'react';
import { inputAdornmentClassName } from '@components/common/formControlStyles';

interface InputAdornmentProps {
  children?: ReactNode;
  position?: 'start' | 'end';
  className?: string;
}

export const InputAdornment: FC<InputAdornmentProps> = ({ children, className }) => (
  <span className={[inputAdornmentClassName, className].filter(Boolean).join(' ')}>{children}</span>
);
